<template>
    <div>
        <div class="hero bg-light int-page">
            <TDSHead/>
        </div>
        <div class="container-fluid bg-light main-content">
            <div class="container py-4 py-lg-8">
                <div class="row">
                    <div class="col-md-8 offset-md-2 mb-3 mb-4 text-center">
                        <h1 class="font-weight-bold text-primary">{{$t('chisiamo.chisiamo_title')}}</h1>
                    </div>
                </div>

                <div class="row pb-4 pb-lg-6">
                    <div class="col-md-8 offset-md-2">
                        <div class="video-responsive video-shadow">
                            <!--<video style="min-width: 100%; min-height: 100%; width: auto; height: auto; top: 50%; z-index: -1; left: 50%; position: absolute; transform: translate(-50%, -50%);" autoplay="autoplay" loop="loop" muted=""><source src="https://player.vimeo.com/external/420992744.hd.mp4?s=43434a1ee96ec3cfedda01498d8f156492924b33&profile_id=175"></video>-->
<iframe src="https://player.vimeo.com/external/420992744.hd.mp4?s=43434a1ee96ec3cfedda01498d8f156492924b33&profile_id=175" width="640" height="360" frameborder="0" autoplay="autoplay" loop="loop" muted="muted" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>                        </div>
                    </div>
                </div>

                <div class="row text-justify">
                    <div class="col-md-8 offset-md-2">
                        <p v-html="$t('chisiamo.chisiamo_p_1')"></p>
                        <p v-html="$t('chisiamo.chisiamo_p_2')"></p>
                        <p v-html="$t('chisiamo.chisiamo_p_3')"></p>
                        <p v-html="$t('chisiamo.chisiamo_p_4')"></p>
                        <p v-html="$t('chisiamo.chisiamo_p_5')"></p>
                    </div>
                </div>
            </div>
        </div>
        <TDSFoot/>
    </div>
</template>

<script>
    import BaseVue from "../views/BaseVue"

    export default {
        extends: BaseVue,
        name: 'chi-siamo',
        metaInfo() {
            return {
                title: 'Chi Siamo - TDS.sport',
            }
        }
    }
</script>
